import Sbill from '@financial/sbill'
import ApprovalClient from '@financial/sbill/dist/approvals/ApprovalClient'
import {ReservationPayload} from '@financial/sbill/dist/approvals/types'

import {isAlphaProfile, isBetaProfile, isDevProfile, isLocalProfile, isTestProfile} from '@web/core/config'
import {BillingSaleChannel} from '@web/core/constants'

export const getEnv = () => {
    if (isLocalProfile || isDevProfile || isAlphaProfile) {
        return 'alpha'
    }
    if (isTestProfile) {
        return 'test'
    }
    if (isBetaProfile) {
        return 'beta'
    }
    return 'real'
}

/** 판매자 충전 주문서는 대상이 아녀서 고정 값 리턴 */
export const getSbillChannel = () => {
    return BillingSaleChannel.NV
}

let sbill: ApprovalClient | undefined
let key: string

const createClient = (reservationPayload: ReservationPayload): ApprovalClient => {
    key = JSON.stringify(reservationPayload)
    return new Sbill.ApprovalClient({
        env: getEnv(),
        reservationPayload,
    })
}

export const getClient = (reservationPayload: ReservationPayload): ApprovalClient => {
    if (!sbill) {
        sbill = createClient(reservationPayload)
    }

    if (!key || key !== JSON.stringify(reservationPayload)) {
        sbill.clear()
        sbill = createClient(reservationPayload)
    }

    return sbill
}
